import React, { useEffect, useState } from "react";
import "./adminPage.scss";
import Modal from "../../components/modal/modal";
import PublishNewsForm from "./components/news/PublishNews/PublishNewsForm";
import { baseUrl } from "../../constants/constants";
import NewsList from "./components/news/NewsList/NewsList";
import NewsArchive from "./components/news/NewsArchive/NewsArchive";
import {successToast} from "../../shared/toastify";
import {ITags} from "../public/NewsPage/news";
import TagsList from "./components/tags/TagsList/TagsList";
import CreateTag from "./components/tags/CreateTag/CreateTag";

export interface INews {
  id: number;
  name: string;
  description: string;
  source_link: string;
  image_url: string;
  create_date: Date;
  dzen_link: string;
  tg_link: string;
  // tags: { [key: string]: boolean };
    tags:{id: number, name: string}[];
  isArchive: boolean
}

const AdminPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [showTagsModal, setShowTagsModal] = useState(false);
  const [news, setNews] = useState<INews[]>([]);
  const [archiveNews, setArchiveNews] = useState<INews[]>([]);
  const [tags, setTags] = useState<ITags[]>([])

  const pageSize = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const [disabled, setDisabled] = useState(false);

    async function switchNewsStatus(id: number) {
    try {
      const res = await fetch(`${baseUrl}news/news_archiving/${id}`, {
        method: "DELETE",
      });
      successToast(`Статус новости изменён`)
      return res.ok;
    } catch (err) {
      return false;
    }
  }

    async function deleteNews(id: number){
      try{
          const res = await fetch(`${baseUrl}news/${id}`, {
              method: "DELETE"
          });
          successToast('Новость удалена')
          return res.ok
      } catch (err){
          console.log(err)
      }
    }

    async function deleteTags(id: number){
      try{
          const res = await fetch(`${baseUrl}tags/${id}`, {
              method: "DELETE"
          });
          successToast('Тег удалён')
          return res.ok
      } catch (err){
          console.log(err)
      }
    }

    // Удаление тега
    const deleteTag = (id: number) => {
        setTags(tags.filter((tag) => tag.id !== id))
    }

    const updateDeleteTag = (currentTag: ITags) => {
        deleteTags(currentTag.id)
        setTags([...tags, {...currentTag}]);
        deleteTag(currentTag.id)
    }

    // Удаление новости
    const destroyNews = (id: number) => {
      setNews(news.filter((news) => news.id !== id))
    }

    const updateDestroyNews = (currentNews: INews) => {
        deleteNews(currentNews.id)
        setNews([...news, {...currentNews, isArchive: false}]);
        destroyNews(currentNews.id)
    }

    // Архивирование новости
  const deletePublicNews = (id: number) => {
    setNews(news.filter((news) => news.id !== id));
  };

  const deleteArchiveNews = (id: number) => {
    setArchiveNews(archiveNews.filter((archiveNews) => archiveNews.id !== id));
  };

  const updateStatusNews = (cuurentNews: INews) => {
    switchNewsStatus(cuurentNews.id);

    if (cuurentNews.isArchive) {
      setNews([...news, { ...cuurentNews, isArchive: false }]);
      deleteArchiveNews(cuurentNews.id);
        successToast("Новость возвращена")
    } else {
        setArchiveNews([...archiveNews, { ...cuurentNews, isArchive: true }]);
        deletePublicNews(cuurentNews.id);
        successToast("Новость в архиве")
    }
  };

  // Запросы новостей
  useEffect(() => {
    fetch(`${baseUrl}news?page=${currentPage}&page_size=${pageSize}&sort_date=true`)
      .then((res) => res.json())
      .then((data) => {
          if(currentPage === 1){
              setNews(data.map((el: INews) => ({ ...el, isArchive: false })));
          } else setNews((prevNews) => [...prevNews, ...data])
      })
      .catch((err) => {
        console.log(err);
      });

      fetch(`${baseUrl}news?page=${currentPage+1}&page_size=${pageSize}&sort_date=true`)
          .then((res) => res.json())
          .then((data) => {
              if(data.length === 0){
                  setDisabled(true)
              } else setDisabled(false)
          })
          .catch((err) => {
              console.log(err);
          });

    fetch(`${baseUrl}news?page_size=8&is_archive=true`)
      .then((res) => res.json())
      .then((data) => {
        setArchiveNews(data.map((el: INews) => ({ ...el, isArchive: true })));
      })
      .catch((err) => {
        console.log(err);
      });

    fetch(`${baseUrl}tags`)
        .then((res) => res.json())
        .then((data) => {
            setTags(data)
        })
    }, [currentPage]);

  const closeModal = () => {
    setShowModal(false);
    setShowTagsModal(false);
    };

  return (
      <>
          <h1 className="admin-title__h1">Редактирование секции "Новости"</h1>
          <div className="admin-buttons">
              <p className="admin-title__p">Создать новость:</p>
              <button onClick={() => setShowModal(true)} className="button admin-btn">
                  Добавить
              </button>
              {showModal && (
                  <Modal active={showModal} title="Описание новости" сlose={closeModal}>
                      <PublishNewsForm close={closeModal} tags={tags}/>
                  </Modal>
              )}
          </div>

          {/*Список всех новостей*/}
          <h2 className="admin-title__h2">Список опубликованных новостей:</h2>
          <div className="one-table">
              <table className="applications-table">
                  <thead className="applications-table__thead">
                  <tr>
                      <th className="applications-table__thead-th">Картинка</th>
                      <th className="applications-table__thead-th">Название</th>
                      <th className="applications-table__thead-th">Описание</th>
                      <th className="applications-table__thead-th">Дата</th>
                      <th className="applications-table__thead-th">Теги</th>
                      <th className="applications-table__thead-th">Действия</th>
                  </tr>
                  </thead>
                  {news.map((i, index) =>
                      <tbody
                          className='applications-table__tbody'
                          key={i.id}
                      >
                      <NewsList
                          news={i}
                          updateStatusNews={updateStatusNews}
                          key={index}
                          tags={tags}
                          deleteNews={updateDestroyNews}
                      />
                      </tbody>
                  )}
              </table>
              <button
                className={disabled ? 'disabledButton button' : 'button'}
                disabled={disabled}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                  Показать ещё
              </button>
          </div>

          {/*Теги*/}
          <h2 className="admin-title__h2">Теги:</h2>
          <div className="admin-buttons">
              <p className="admin-title__p">Создать тег:</p>
              <button onClick={() => setShowTagsModal(true)} className="button admin-btn">
                  Добавить
              </button>
              {showTagsModal && (
                  <Modal active={showTagsModal} title="Введите название тега" сlose={closeModal}>
                      <CreateTag close={closeModal}/>
                  </Modal>
              )}
          </div>
          <div className={'admin_tags'}>
              {tags.length > 0 ? tags.map((tag, index) => (
                      <TagsList
                          key={index}
                          tags={tag}
                          deleteTag={updateDeleteTag}
                      />
                  ))
                  :
                  <h2>Тегов нет</h2>}
          </div>

          {/*Список архивных новостей*/}
          <h2 className="admin-title__h2">Список архивных новостей:</h2>
          <div className="one-table">
              <table className="applications-table">
                  <thead className="applications-table__thead">
                  <tr>
                      <th className="applications-table__thead-th">Картинка</th>
                      <th className="applications-table__thead-th">Название</th>
                      <th className="applications-table__thead-th">Описание</th>
                      <th className="applications-table__thead-th">Дата</th>
                      <th className="applications-table__thead-th">Теги</th>
                      <th className="applications-table__thead-th">Действия</th>
                  </tr>
                  </thead>
                  {archiveNews.map((i) =>
                      <tbody
                          className='applications-table__tbody'
                          key={i.id}
                      >
                      <NewsArchive
                          news={i}
                          updateStatusNews={updateStatusNews}
                      />
                      </tbody>
                  )}
              </table>
          </div>
      </>
  );
};

export default AdminPage;